import _ from 'lodash';
import {
  SELECT_ADMIN_TAB,
  FETCH_ADMIN_DATA_SUCCESS,
  FETCH_ADMIN_REPORT_CATEGORY_DATA_SUCCESS,
  DELETE_CATEGORY_ADMIN_REQUEST,
  SAVE_CATEGORY_ADMIN_SUCCESS,
  EDIT_ADMIN_REPORT_DATA_SUCCESS,
  DOWNLOAD_USER_GUIDE_SUCCESS,
  SET_TAB_STATUS, EDIT_CATEGORY_ADMIN_SUCCESS,
} from '../actions/types/AdminDashboardActionTypes';

export const initialState = {
  activeTab: '',
  adminReportsList: [],
  reportCategory: [],
  returnSuccess: {},
  file: '',
  filename: '',
  tabStatus: false,
};

const handleFetchAdminReportsListSuccess = (action, state) => ({
  ...state,
  adminReportsList: [...action.payload.adminReports].sort((a, b) => a.reportNo.localeCompare(b.reportNo)),
});
const handleFetchAdminReportCategorySuccess = (action, state) => ({
  ...state,
  reportCategory: [...action.payload.category],
});

const handleSelectTab = (action, state) => ({
  ...state,
  activeTab: action.activeTab,
});

const handleSetTabStatus = (action, state) => ({
  ...state,
  tabStatus: action.status,
});

const handleAdminCategoryDeleteRequest = (action, state) => {
  let reportCategory = [...state.reportCategory];
  reportCategory = reportCategory.filter(item => item.name !== action.payload.categoryName);
  reportCategory.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    reportCategory,
  };
};

const handleAdminCategoryAddRequest = (action, state) => {
  const reportCategory = [...state.reportCategory];

  const indexOfExistingSelection = _.findIndex(reportCategory, { name: action.payload.object });
  const newSelection = action.payload;

  if (indexOfExistingSelection === -1) {
    reportCategory.push(newSelection);
  } else {
    reportCategory[indexOfExistingSelection] = newSelection;
  }

  // reportCategory.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    reportCategory,
  };
};

const handleAdminEditReportSuccess = (action, state) => {
  const adminReportsList = [...state.adminReportsList];

  const indexOfExistingSelection = _.findIndex(adminReportsList, { reportCode: action.payload.reportCode });
  const newSelection = action.payload;

  if (indexOfExistingSelection === -1) {
    adminReportsList.push(newSelection);
  } else {
    adminReportsList[indexOfExistingSelection] = newSelection;
  }
  // adminReportsList.sort((a, b) => a.reportCode.localeCompare(b.reportCode));
  return {
    ...state,
    adminReportsList,
  };
};

const handleAdminEditCategorySuccess = (action, state) => {
  const reportCategory = [...state.reportCategory];
  const indexOfExistingSelection = _.findIndex(reportCategory, { categoryId: action.payload.categoryId });
  const newSelection = action.payload;

  if (indexOfExistingSelection === -1) {
    reportCategory.push(newSelection);
  } else {
    reportCategory[indexOfExistingSelection] = newSelection;
  }
  // adminReportsList.sort((a, b) => a.reportCode.localeCompare(b.reportCode));
  return {
    ...state,
    reportCategory,
  };
};

const adminDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case SELECT_ADMIN_TAB:
      return handleSelectTab(action, state);
    case FETCH_ADMIN_DATA_SUCCESS:
      return handleFetchAdminReportsListSuccess(action, state);
    case FETCH_ADMIN_REPORT_CATEGORY_DATA_SUCCESS:
      return handleFetchAdminReportCategorySuccess(action, state);
    case DELETE_CATEGORY_ADMIN_REQUEST:
      return handleAdminCategoryDeleteRequest(action, state);
    case SAVE_CATEGORY_ADMIN_SUCCESS:
      return handleAdminCategoryAddRequest(action, state);
    case EDIT_ADMIN_REPORT_DATA_SUCCESS:
      return handleAdminEditReportSuccess(action, state);
    case EDIT_CATEGORY_ADMIN_SUCCESS:
      return handleAdminEditCategorySuccess(action, state);
    case DOWNLOAD_USER_GUIDE_SUCCESS:
      return {
        file: action.payload.file,
        filename: action.payload.filename,
      };
    case SET_TAB_STATUS:
      return handleSetTabStatus(action, state);
    default:
      return state;
  }
};

export default adminDataReducer;
